import React from "react";
import classes from "./NewSlidePopup.module.css"
import Slide from "./Slide";
import * as contentTypes from './contentTypes';
import { useSelector } from "react-redux";

const NewSlidePopup = ({ close, onCreateNewSlide }) => {

    const { texts } = useSelector(state => state.translate);

    const handleClick = (type) => {
        onCreateNewSlide(type);
        close();
    }
    return <div className={classes.NewSlideBD} onClick={close}>
        <div className={classes.NewSlidePopup} onClick={(e) => e.stopPropagation()}>
            <div className={classes.Header}>
                <div>{texts.whichSlideWouldYouLikeToMake}</div>
            </div>
            <div className={classes.Slides}>
                <Slide type={contentTypes.tinyMCE} name={texts.blankSlide} dropClass={classes.BorderAndShaddow} onClick={() => handleClick(contentTypes.tinyMCE) }></Slide>
                <Slide type={contentTypes.quetion} name={texts.questionSlide} dropClass={classes.BorderAndShaddow} onClick={() => handleClick(contentTypes.quetion)}></Slide>
                <Slide type={contentTypes.file} name={texts.importPresentationOrPdf} dropClass={classes.BorderAndShaddow} onClick={() => handleClick(contentTypes.file)}></Slide>
                <Slide type={contentTypes.image} name={texts.image} dropClass={classes.BorderAndShaddow} onClick={() => handleClick(contentTypes.image)}></Slide>
            </div>
        </div>
    </div>
}
export default NewSlidePopup;